module.exports = __webpack_public_path__ + "img/logo-under construction.2bc54f53.png";